/* ═══════════════════════════════════════════════════════════════
   ELEGANCE V2 — interactions
   3D scroll hero · floating nav · reveals · counters · tilt
   before/after · tabs · swatches · smart video
   ═══════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(Math.max(v, a), b); };

  /* ── rAF scroll bus ───────────────────────────────────────── */
  var subs = [], ticking = false;
  function onScroll(fn) { subs.push(fn); }
  function flush() {
    var y = window.scrollY || window.pageYOffset;
    for (var i = 0; i < subs.length; i++) subs[i](y);
    ticking = false;
  }
  window.addEventListener("scroll", function () {
    if (!ticking) { ticking = true; requestAnimationFrame(flush); }
  }, { passive: true });
  window.addEventListener("resize", function () {
    if (!ticking) { ticking = true; requestAnimationFrame(flush); }
  }, { passive: true });

  /* ── 1. Scroll progress (JS fallback) ─────────────────────── */
  var bar = $("#progress");
  if (bar && !CSS.supports("animation-timeline: scroll()")) {
    onScroll(function (y) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = "scaleX(" + (h > 0 ? y / h : 0) + ")";
    });
  }

  /* ── 2. Floating nav: auto-hide + solid ───────────────────── */
  var nav = $("#fnav");
  if (nav) {
    // stays fixed & visible at all times (sticky feel); only its surface reacts to scroll
    onScroll(function (y) {
      nav.dataset.solid = y > 40 ? "true" : "false";
      if (!(msheet && msheet.classList.contains("is-open"))) nav.dataset.hidden = "false";
    });
  }

  /* ── 3. Mobile/tablet off-canvas menu (mechanics ported from v1's mobile-menu) ── */
  var burger = $("#burger"), msheet = $("#msheet"), msheetClose = $("#msheetClose"), moverlay = $("#moverlay");
  if (burger && msheet && moverlay) {
    var setMsheet = function (open) {
      msheet.classList.toggle("is-open", open);
      msheet.setAttribute("aria-hidden", String(!open));
      burger.setAttribute("aria-expanded", String(open));
      burger.setAttribute("aria-label", open ? "Cerrar menú" : "Abrir menú");
      moverlay.hidden = !open;
      requestAnimationFrame(function () { moverlay.classList.toggle("is-visible", open); });
      document.body.style.overflow = open ? "hidden" : "";
      // the floating nav and the off-canvas menu must never be visible together
      if (nav) nav.dataset.hidden = open ? "true" : "false";
    };
    burger.addEventListener("click", function () { setMsheet(msheet.classList.contains("is-open") ? false : true); });
    if (msheetClose) msheetClose.addEventListener("click", function () { setMsheet(false); });
    moverlay.addEventListener("click", function () { setMsheet(false); });
    // real navigation links close the panel; the accordion <summary> toggles stay open
    $$("a", msheet).forEach(function (a) { a.addEventListener("click", function () { setMsheet(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setMsheet(false); });
  }

  /* ── 4. HERO 3D deck (scroll-linked) ──────────────────────── */
  var hero = $(".hero"), deck = $("#deck");
  if (hero && deck && !RM) {
    onScroll(function (y) {
      var h = hero.offsetHeight || 1;
      var p = clamp(y / h, 0, 1);                 // 0 → 1 across the hero
      var rx = p * 13;                            // tilt back in 3D
      var tz = p * -260;                          // recede
      var sc = 1 - p * 0.09;                      // subtle shrink
      deck.style.setProperty("--rx", rx.toFixed(2) + "deg");
      deck.style.setProperty("--tz", tz.toFixed(1) + "px");
      deck.style.setProperty("--sc", sc.toFixed(3));
      deck.style.opacity = String(1 - p * 0.55);
    });

    /* pointer parallax on the 3D deck (desktop only) */
    if (window.matchMedia("(pointer: fine)").matches) {
      var rx0 = 0, ry0 = 0, rxT = 0, ryT = 0, raf = null;
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        ryT = ((e.clientX - r.left) / r.width - 0.5) * 7;
        rxT = ((e.clientY - r.top) / r.height - 0.5) * -4;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      hero.addEventListener("pointerleave", function () { rxT = 0; ryT = 0; if (!raf) raf = requestAnimationFrame(loop); });
      function loop() {
        rx0 += (rxT - rx0) * 0.08;
        ry0 += (ryT - ry0) * 0.08;
        deck.style.setProperty("--mrx", rx0.toFixed(2) + "deg");
        deck.style.setProperty("--mry", ry0.toFixed(2) + "deg");
        deck.style.rotate = "";
        deck.style.transform =
          "rotateX(calc(var(--rx,0deg) + " + rx0.toFixed(2) + "deg)) " +
          "rotateY(" + ry0.toFixed(2) + "deg) " +
          "translateZ(var(--tz,0px)) scale(var(--sc,1))";
        raf = (Math.abs(rxT - rx0) > 0.01 || Math.abs(ryT - ry0) > 0.01) ? requestAnimationFrame(loop) : null;
      }
    }
  }

  /* ── 5. Reveal on enter ───────────────────────────────────── */
  var revealables = $$(".rv, .lmask, .iclip");
  if ("IntersectionObserver" in window && !RM) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealables.forEach(function (el) { io.observe(el); });

    // Catch-up: instant jumps (anchor nav / deep-links) can skip IO's intersecting
    // frame, leaving clipped media hidden. Reveal anything at or above the fold.
    onScroll(function () {
      var vh = window.innerHeight;
      revealables.forEach(function (el) {
        if (el.classList.contains("in")) return;
        var t = el.getBoundingClientRect().top;
        if (t < vh * 0.92) { el.classList.add("in"); io.unobserve(el); }
      });
    });
  } else {
    revealables.forEach(function (el) { el.classList.add("in"); });
  }

  /* ── 6. Counters ──────────────────────────────────────────── */
  function runCount(el) {
    var target = parseFloat(el.dataset.count),
        suffix = el.dataset.suffix || "",
        t0 = null, dur = 1700;
    if (RM) { el.textContent = target.toLocaleString("es-ES") + suffix; return; }
    function step(t) {
      if (!t0) t0 = t;
      var p = clamp((t - t0) / dur, 0, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString("es-ES") + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = $$("[data-count]");
  if ("IntersectionObserver" in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  } else { counters.forEach(runCount); }

  /* ── 7. Manifesto: word-by-word scroll reveal ─────────────── */
  var mt = $("#manifestoText");
  if (mt) {
    var words = mt.textContent.trim().split(/\s+/);
    mt.textContent = "";
    words.forEach(function (w, i) {
      var s = document.createElement("span");
      s.className = "w";
      // highlight the emotional payload
      if (/reconoces|espejo/i.test(w)) s.classList.add("gold");
      s.textContent = w;
      mt.appendChild(s);
      if (i < words.length - 1) mt.appendChild(document.createTextNode(" "));
    });
    var ws = $$(".w", mt);
    if (RM) { ws.forEach(function (w) { w.classList.add("on"); }); }
    else {
      onScroll(function () {
        var r = mt.getBoundingClientRect(), vh = window.innerHeight;
        var p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35), 0, 1);
        var n = Math.round(p * ws.length);
        ws.forEach(function (w, i) { w.classList.toggle("on", i < n); });
      });
    }
  }

  /* ── 8. Category 3D tilt ──────────────────────────────────── */
  if (!RM && window.matchMedia("(pointer: fine)").matches) {
    $$(".tilt").forEach(function (card) {
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          "perspective(900px) rotateY(" + (px * 7).toFixed(2) + "deg) rotateX(" +
          (py * -7).toFixed(2) + "deg) translateY(-6px)";
      });
      card.addEventListener("pointerleave", function () { card.style.transform = ""; });
    });
  }

  /* ── 9. Method tabs ───────────────────────────────────────── */
  var tabs = $$(".tab");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) { t.setAttribute("aria-selected", "false"); });
      tab.setAttribute("aria-selected", "true");
      $$(".panel").forEach(function (p) {
        p.dataset.on = String(p.dataset.panel === tab.dataset.tab);
      });
    });
  });

  /* ── 10. Before / after slider ────────────────────────────── */
  var ba = $("#ba");
  if (ba) {
    var dragging = false;
    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var pct = clamp(((clientX - r.left) / r.width) * 100, 0, 100);
      ba.style.setProperty("--pos", pct + "%");
    }
    ba.addEventListener("pointerdown", function (e) { dragging = true; ba.setPointerCapture(e.pointerId); setPos(e.clientX); });
    ba.addEventListener("pointermove", function (e) { if (dragging) setPos(e.clientX); });
    ba.addEventListener("pointerup",   function () { dragging = false; });
    ba.addEventListener("pointercancel", function () { dragging = false; });
    // hover-scrub on desktop
    if (window.matchMedia("(pointer: fine)").matches) {
      ba.addEventListener("pointermove", function (e) { if (!dragging) setPos(e.clientX); });
    }
    // keyboard
    ba.setAttribute("tabindex", "0");
    ba.setAttribute("role", "slider");
    ba.setAttribute("aria-label", "Comparar antes y después");
    ba.setAttribute("aria-valuemin", "0"); ba.setAttribute("aria-valuemax", "100"); ba.setAttribute("aria-valuenow", "50");
    ba.addEventListener("keydown", function (e) {
      var cur = parseFloat(ba.style.getPropertyValue("--pos")) || 50;
      if (e.key === "ArrowLeft")  { cur = clamp(cur - 4, 0, 100); ba.style.setProperty("--pos", cur + "%"); ba.setAttribute("aria-valuenow", cur); e.preventDefault(); }
      if (e.key === "ArrowRight") { cur = clamp(cur + 4, 0, 100); ba.style.setProperty("--pos", cur + "%"); ba.setAttribute("aria-valuenow", cur); e.preventDefault(); }
    });
    // gentle auto-demo the first time it enters view
    if (!RM && "IntersectionObserver" in window) {
      var demoed = false;
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) {
          if (e.isIntersecting && !demoed) {
            demoed = true;
            var t0 = null;
            requestAnimationFrame(function anim(t) {
              if (!t0) t0 = t;
              var p = clamp((t - t0) / 1600, 0, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              ba.style.setProperty("--pos", (50 + Math.sin(eased * Math.PI) * 26) + "%");
              if (p < 1) requestAnimationFrame(anim);
            });
            obs.disconnect();
          }
        });
      }, { threshold: 0.45 }).observe(ba);
    }
  }

  /* ── 11. Swatches ─────────────────────────────────────────── */
  var picked = $("#swPicked"), swWa = $("#swWa");
  $$(".sw").forEach(function (sw) {
    sw.addEventListener("click", function () {
      $$(".sw").forEach(function (s) { s.setAttribute("aria-pressed", "false"); });
      sw.setAttribute("aria-pressed", "true");
      var tone = sw.dataset.tone || "";
      if (picked) picked.innerHTML = "Tono seleccionado: <b>" + tone + "</b>";
      if (swWa) {
        swWa.href = "https://wa.me/34615430785?text=" +
          encodeURIComponent("Hola, he elegido el tono " + tone + " y quisiera asesorarme sobre extensiones de pelo");
      }
    });
  });

  /* ── 12. Smart video: only play what's on screen ──────────── */
  var vids = $$("video");
  // reveal the video only once a frame is actually decoding — the poster <img>
  // (or the .vcard dark fallback background) stays visible until then, so a
  // stalled/blocked/unsupported video never shows as a blank black card
  vids.forEach(function (v) {
    v.addEventListener("playing", function () { v.classList.add("is-ready"); });
  });
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === "none") v.preload = "metadata";
          if (!RM) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else { v.pause(); }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { vio.observe(v); });
  }
  if (RM) vids.forEach(function (v) { v.removeAttribute("autoplay"); v.pause(); });

  /* ── 13. Newsletter stub ──────────────────────────────────── */
  var nf = $("#newsForm");
  // un formulario real de Shopify (con action) tiene que enviarse; solo se simula el de la maqueta estática
  if (nf && !nf.getAttribute("action")) {
    nf.addEventListener("submit", function (e) {
      e.preventDefault();
      var b = nf.querySelector("button"), prev = b.textContent;
      b.textContent = "✓"; b.disabled = true;
      setTimeout(function () { b.textContent = prev; b.disabled = false; nf.reset(); }, 2400);
    });
  }

  /* ── 14. Smooth in-page anchors offset for the floating nav ─
     Handles both "#seccion" and "/#seccion". The root-relative form is used
     sitewide so the shared footer/nav also works from the inner pages; when we
     are already on the homepage we intercept it and scroll instead of navigating. */
  $$('a[href^="#"], a[href^="/#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href");
      var id = href.charAt(0) === "/" ? href.slice(1) : href;
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;                      // not on this page → let the browser navigate
      e.preventDefault();
      var top = t.getBoundingClientRect().top + window.scrollY - 92;
      window.scrollTo({ top: top, behavior: RM ? "auto" : "smooth" });
      if (history.replaceState) history.replaceState(null, "", id);
    });
  });

  flush();
})();
